export const Leaguestructure = {
  

    zonal_league : {

        intro : "At Outlast Football Academy, We are Conducting The Intra - Zonal League, an Exciting Competition Designed to foster competitive Spirit and Teamwork among Our Student",
        structure : [
            {
                id:1,
                name:"ZONES AND TEAMS",
                content:"The League Consists Of 3 Zones Each Zone will have 3 Teams Represention Them "
            },
            {
                id:2,
                name: "MATCH PHASES",
                content:"Zone matches: Matches will be held within each zone. Each team will compete against the other teams in their respective zone",
                content_2 : "Final Rounds: The winners and runners - ups from each zone will advance to the final rounds"
            },
            {
                id:3,
                name:"FINAL SHOWDOWN",
                content:"The top teams from each zone will compete in the final round the final will determine the overall INTRA-ZONAL LEAGUE WINNERS"
            }
        ]
       
    } ,


    outlast_league : {
        intro : "Outlast Super League (OSL) a premiere event designed The Outlast super league to bring together all the venues associated with Outlast Football Academy in a Thrilling and competitive football league. This league is structured to provide a comprehensive platformfor showcasing talent and fostering sportsmanship",
        structure : [
            {
                id:1,
                name :"PARTICIPANTS",
                content : "All venue under the Outlast Football Academy Umbrella will participate in the league"
            },
            {
                id:2,
                name:"MATCH FORMAT",
                content:['The League will follow a round-robin format, where each teams plays against every other teams' , 'Matches Will be held on a league basis, ensuring every team gets the chance to compete against all other teams']
            },
            {
                id:3,
                name:"ADVANCEMENT TO SEMIS AND FINALS",
                content:['The Teams will earn points based on their performance in each match, which will be reflected on the points table' ,  'The top four teams with the highest points at the end of the league matches then grand final to determine the champion of the Outlast Super League']
            }
        ]
    }

}



